import { MemoryRouter as Router, Routes, Route } from 'react-router-dom'
import Welcome from './components/welcome'
import Guide from './components/guide'
import Group from './components/group'
import Code from './components/code'
import Credits from './components/credits'
import Faq from './components/faq'
import 'animate.css'
import './Main.scss'

import routes from './data/categoriesData'
import products from './data/productsData'

const goRoutes = routes.map((item, index) => (
  <Route key={index} path={`/${item.url}`} element={
    <Group 
      title = {item.title}
      subtitle = {item.subtitle}
      category = {item.category}
      products = {item.products}
      prev = {item.prev} prevStep = {item.prevStep}
    />} 
  />
))

const goProducts = products.map((item, index) => (
  <Route key={index} path={`/${item.url}`} element={
    <Code
      title = {item.title}
      subtitle = {item.subtitle}
      category = {item.category}
      code = {item.code}
      prev = {item.prev} prevStep = {item.prevStep}
      next = {item.next} nextStep = {item.nextStep}
    />} 
  />
))

function App() {
  return (
    // ReactRouter to switch pages 
    <Router>
      <Routes>
        <Route path="/" element={<Welcome 
          title = 'Print and Service Solutions' />} 
          subtitle = 'Product Code Wizard'
        />
        <Route path="/faq" element={<Faq />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/credits" element={<Credits />} />
        {goRoutes}
        {goProducts}
      </Routes>
    </Router>
  )
}

export default App